import ActivityTypeSelect from "./ActivityTypeSelect"
import CategorySlidebar from "./CategorySlidebar";
import { Capacitor } from "@capacitor/core";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import useWindowWidth from "../../hooks/useWindowWidth";
import useScrollPosition from "../../hooks/useScrollPosition";
import AllFilters from "./AllFilters";
import FiltersButton from "../filters/FiltersButton";
import { useTranslation } from "react-i18next";
import { setNewFilters } from "../../redux/filtersSlice";
import { setScroll } from "../../redux/scrollSlice";

const Pool = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const scrollPosition = useScrollPosition();
    const windowWidth = useWindowWidth();

    // In app nativa la Pool si aggancia sotto la status bar, e la fascia sopra è coperta da
    // StatusBarBackdrop. Sul web quella fascia non è coperta da nulla: agganciandosi a 20px
    // si vedevano scorrere le card nella striscia rimasta scoperta sopra la barra.
    const isNativePlatform = Capacitor.isNativePlatform();

    // Gestisco l'apertura/chiusura della Pool in AllActivities
    const filters = useSelector(state => state.filters);
    const [isAllFiltersOpen, setIsAllFiltersOpen] = useState(false);

    // Funzione per contare i filtri attivi
    function countActiveFilters(filters) {
        let count = 0;
        if (filters.activityType.length > 0) count++;
        if (filters.region.length > 0) count++;
        if (filters.groupModel.length > 0) count++;
        if (filters.availablePeriod.length > 0) count++;
        if (filters.difficultyLevel.length > 0) count++;
        if (filters.other.length > 0) count++;
        if (filters.activityDuration?.length > 0) count++;
        return count;
    }

    // Blocco lo scroll della pagina se AllFilters è aperto
    useEffect(() => {
        if (isAllFiltersOpen && windowWidth < 768) {
            dispatch(setScroll(false))
        } else {
            dispatch(setScroll(true))
        }
    }, [isAllFiltersOpen, windowWidth, dispatch])

    return (
        <div className={`
                w-full z-20
                ${windowWidth < 768 ? (isNativePlatform ? 'sticky top-[max(env(safe-area-inset-top),20px)]' : 'sticky top-0') : ''}
            `}>

            {/* Barra di ricerca */}
            <div className={`
                        ${scrollPosition > 40 ? 'mx-[-16px] shadow' : 'border rounded-xl'}
                        z-10 bg-[#f7f7f8] py-2 pl-3 pr-4 cursor-pointer
                        flex flex-col justify-center items-center
                        `}
            >
                {
                    filters.search &&
                    <div className="w-full flex justify-center items-center gap-x-2 text-sm mb-2">
                        <div className="text-xs text-[#225424]">{t('poolBar.keyword')}</div>
                        <div
                            className="
                                w-fit px-2 rounded-xl border border-[#225424]
                                flex gap-x-2 items-center
                                "
                        >{filters.search} <i className="fi fi-rr-circle-xmark mt-1.5 text-xl cursor-pointer" onClick={() => dispatch(setNewFilters({ search: '' }))}></i></div>
                    </div>
                }
                {
                    <ActivityTypeSelect />
                }
                {
                    <CategorySlidebar isSmall={true} />
                }
                {
                    !isAllFiltersOpen &&
                    <FiltersButton
                        onClick={() => setIsAllFiltersOpen(true)}
                        activeCount={countActiveFilters(filters)}
                    />
                }
            </div>

            {/* AllFilters renderizzato a livello outer del Pool, accessibile sia da Pool aperta (desktop)
                sia da Pool chiusa (mobile, sotto). Su mobile usa createPortal e finisce in body. */}
            {
                isAllFiltersOpen && (
                    <div className="w-full flex justify-center">
                        <AllFilters onClose={() => setIsAllFiltersOpen(false)} />
                    </div>
                )
            }
        </div>
    )
}

export default Pool